import { push } from "connected-react-router";

export default function createGoTo(getLocationParams) {
  return (args) => push(getLocationParams(args));
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/actions/router/createGoTo.js